export default (canEditEngId: boolean) => [
  {
    field: 'name',
    headerName: 'Name',
    description: 'Name',
    type: 'string',
    width: 200,
    align: 'left',
    headerAlign: 'left',
    editable: true,
  },
  {
    field: 'engineeringId',
    headerName: 'Engineering ID',
    description: 'Engineering ID',
    type: 'string',
    width: 200,
    align: 'left',
    headerAlign: 'left',
    editable: canEditEngId,
  },
  {
    field: 'deviceId',
    headerName: 'Device ID',
    description: 'Device ID',
    type: 'string',
    width: 200,
    align: 'left',
    headerAlign: 'left',
    editable: false,
  },
  {
    field: 'type',
    headerName: 'Type',
    description: 'Type',
    type: 'string',
    width: 200,
    align: 'left',
    headerAlign: 'left',
    editable: false,
  },
  {
    field: 'parentControllerId',
    headerName: 'Parent Controller ID',
    description: 'Parent Controller ID',
    type: 'string',
    width: 200,
    align: 'left',
    headerAlign: 'left',
    editable: false,
  },
  {
    field: 'isSiteControllerSourceDevice',
    headerName: 'Is Site Controller Source Device?',
    description: 'Is Site Controller Source Device?',
    type: 'boolean',
    width: 200,
    align: 'left',
    headerAlign: 'left',
    editable: false,
  },
  {
    field: 'parentSourceDeviceId',
    headerName: 'Parent Source Device ID',
    description: 'Parent Source Device ID',
    type: 'string',
    width: 200,
    align: 'left',
    headerAlign: 'left',
    editable: false,
  },
];
